document.addEventListener('DOMContentLoaded', function () {
  const forms = [
    { formId: 'newsletter-footer', emailInputSelector: 'input[type="email"]' },
    { formId: 'fieldCaptureForm', emailInputSelector: 'input[type="email"]' }
  ];

  const storedEmail = localStorage.getItem('newsletterEmail');

  if (!storedEmail) {
    forms.forEach(function (formInfo) {
      const contactForm = document.getElementById(formInfo.formId);

      if (contactForm) {
        contactForm.addEventListener('submit', function (event) {
          // Prevent the default form submission to perform actions first
          event.preventDefault();

          // Get the email input field within the form
          const emailInput = contactForm.querySelector(formInfo.emailInputSelector);
          const email = emailInput ? emailInput.value.trim().toLowerCase() : null;

          if (email) {
            // Store the email in localStorage
            localStorage.setItem('newsletterEmail', email);

            // Manually submit the form after storing the email
            contactForm.submit();
          }
        });
      }
    });
  } else {
    // Hash the email and send the result
    sha256(storedEmail).then(hashedEmail => {
      
      !function(w, d, s, t, a) {
        if (w.amzn) return;
        w.amzn = a = function() { w.amzn.q.push([arguments, (new Date).getTime()]) };
        a.q = []; a.version = "0.0";
        s = d.createElement("script");
        s.src = "https://c.amazon-adsystem.com/aat/amzn.js";
        s.id = "amzn-pixel";
        s.async = true;
        t = d.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(s, t);
      }(window, document);

      amzn("setRegion", "NA");
      amzn("addTag", "31f79e9a-db46-401c-ac0e-bfd61b802ae8");
      amzn("trackEvent", "Signup", { email: hashedEmail });

      // Push the email event to the dataLayer for optional GTM tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Signup',
        'email': hashedEmail
      });

      localStorage.removeItem('newsletterEmail');
    });
  }
});

// SHA-256 hash function
async function sha256(str) {
  const msgBuffer = new TextEncoder().encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(byte => ('00' + byte.toString(16)).slice(-2)).join('');
  return hashHex;
}